// Qwen (Alibaba) mark for the Qwen models — the interlocking hexagonal knot in Qwen purple on the
// same 16px white tile the other icons use.
export default function QwenIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="2" fill="white" />
      <path
        d="M8 2.2L13.2 5.1V10.9L8 13.8L2.8 10.9V5.1L8 2.2ZM8 4.1L4.5 6.05V9.95L8 11.9L11.5 9.95V6.05L8 4.1Z"
        fill="#615CED"
      />
      <path
        d="M6.1 6.9H9.9L11.3 9.4H8.9L8 7.85L7.1 9.4H4.7L6.1 6.9Z"
        fill="#615CED"
      />
    </svg>
  );
}
